import { combineReducers, configureStore } from '@reduxjs/toolkit';
import accountReducer from './account/slice';
import appReducer from './app/slice';
import modalReducer from './modal/slice';
import resellerReducer from './reseller/slice';
import resellerTourReducer from './resellerTour/slice';
import resellerAcademyReducer from './resellerAcademy/slice';
import variableReducer from './novi/variables/slice';
import resellerOnboardingReducer from './resellerOnboardingSteps/slice';
import workflowIssuesReducer from './workflowsAnalysis/slice';
import textingReducer from './textingPlatform/slice';
import scenarioCountsReducer from './scenarioCounts/slice';
import calendarEventsReducer from './calendarEvents/slice';
import phoneNumberReducer from './phoneNumber/slice';

const rootReducer = combineReducers({
	app: appReducer,
	account: accountReducer,
	modal: modalReducer,
	reseller: resellerReducer,
	resellerTour: resellerTourReducer,
	resellerAcademy: resellerAcademyReducer,
	variableManager: variableReducer,
	resellerOnboarding: resellerOnboardingReducer,
	workflowIssues: workflowIssuesReducer,
	textingPlatform: textingReducer,
	scenarioCounts: scenarioCountsReducer,
	calendarEvents: calendarEventsReducer,
	phoneNumber: phoneNumberReducer,
});

export const store = configureStore({
	reducer: rootReducer,
	devTools: {
		serialize: true,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
